export default "__VITE_ASSET__CKSUG0R9__ 584w";